import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { OrganizationGoal } from '../model/organization/organization-goal.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoalService {
  private httpClient = inject(HttpClient);

  public getGoalList(): Observable<OrganizationGoal[]> {
    return this.httpClient.get<any[]>(
      `${environment.apiUrl}/api/heritage-goals`,
    ).pipe(
      map((responseList: any[]): OrganizationGoal[] => (responseList ?? []).map(
        (response: any): OrganizationGoal => OrganizationGoal.createFromApi(response),
      )),
    );
  }
}
